"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function NoteIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M14.751,1.768H6.829A2.588,2.588,0,0,0,4.215,4.323V19.676a2.589,2.589,0,0,0,2.614,2.556H17.171a2.589,2.589,0,0,0,2.614-2.556V6.759Zm2.42,18.765H6.829a.888.888,0,0,1-.914-.857V4.323a.887.887,0,0,1,.914-.856h6.933V6.7a.937.937,0,0,0,.937.936h3.386V19.676A.888.888,0,0,1,17.171,20.533Z" }),
        react_1.default.createElement("polygon", { points: "8.178 16.522 11.994 9.706 15.822 16.515 8.178 16.522" })));
}
exports.default = NoteIcon;
